// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetModalVisibility = () => getDefaultState().isFullDebitModalVisible;

const updateModalVisibility = (state, action) => action.visibility;

export default (state = getDefaultState().isFullDebitModalVisible, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_CLAIM_DEBIT]: resetModalVisibility,
        [actions.UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_MODAL_VISIBILITY]: updateModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/reducers/full-debit-modal.js